<div class="card card-flush h-xl-100">
  <div class="card-body pt-5">
    <nz-page-header [nzGhost]="false">
      <nz-page-header-title>Email Group Mapping List</nz-page-header-title>
      <nz-page-header-subtitle>Manage your Email Group Mapping here</nz-page-header-subtitle>
      <nz-page-header-extra>
        @if (permission.Add) {
          <button nz-button nzType="primary" (click)="showModal()">
            Add New
          </button>
        }
      </nz-page-header-extra>
    </nz-page-header>
    <nz-divider></nz-divider>

    <div style="padding: 8px; float: right">
      <input type="text" style="width: 250px; margin-right: 8px" nz-input placeholder="Search stage name"
        [(ngModel)]="searchValue" (keydown)="onKeydown($event)" (ngModelChange)="ValidateText()" />

      <button nz-button nzSize="small" nzType="primary" (click)="search()" style="margin-right: 8px">
        Search
      </button>

      <button nz-button nzSize="small" (click)="reset()">Reset</button>
      <button nz-button nzSize="small" (click)="export()">
        <i nz-icon nzType="export" nzTheme="outline"></i> Export
      </button>
    </div>

    <nz-table [nzPageSize]="100" style="width: 100%" nzBordered [nzScroll]="{ x: '1200px', y: '515px' }" nzSize="small"
      #basicTable [nzData]="this.EmailGroupMappingList" [nzLoading]="isTableLoading">
      <thead>
        <tr>
          <th nzWidth="50px" nzLeft>S.No</th>
          <th nzWidth="150px">Stage Name</th>
          <th nzWidth="60px">Notification Group User Name</th>
          <th nzWidth="60px">Enabled</th>
          <th nzWidth="100px">Added By</th>
          <th nzWidth="100px">Added Date</th>
          <th nzWidth="160px" nzRight style="text-align: center">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (data of this.EmailGroupMappingList; track data; let i = $index) {
          <tr>
            <td nzLeft>{{ data.SerialNumber }}</td>
            <td>{{ data.StageName }}</td>
            <td>{{ data.NotificationGroupUserName }}</td>
            <td>{{ data.Enabled }}</td>
            <td>{{ data.AddedBy }}</td>
            <td>{{ data.AddedDate | DatetimeConverter }}</td>
            <td nzRight style="text-align: center">
              @if (permission.Edit) {
                <button class="btn btn-sm btn-light-primary" (click)="editEmailGrouping(data)">
                  Edit
                </button>
              }
              &nbsp;
              @if (permission.Delete) {
                <button class="btn btn-sm btn-light-danger" (click)="handleDelete(data)">
                  Delete
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </nz-table>

    <nz-modal [(nzVisible)]="isVisible" [nzStyle]="{ top: '20px' }" [nzTitle]="modalTitle" [nzContent]="modalContent"
      [nzFooter]="modalFooter" (nzOnCancel)="handleCancel()">
      <ng-template #modalTitle>{{ EmailGroupMappingTitle }}</ng-template>
      <ng-template #modalContent>
        <form nz-form [formGroup]="validateForm">
          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Stage Name</nz-form-label>
            <nz-form-control [nzSpan]="14" nzValidateStatus="success">
              <nz-select name="select-error1" nzShowSearch formControlName="StageId">
                <nz-option nzValue="0" nzLabel="Select Stage"></nz-option>
                @for (stage of OrderStages; track stage) {
                  <nz-option [nzValue]="stage.id" [nzLabel]="stage.name"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Notification Group</nz-form-label>
            <nz-form-control [nzSpan]="14" nzValidateStatus="success">
              <nz-select name="select-error2" nzShowSearch formControlName="NotificationGroupUserId">
                <nz-option nzValue="0" nzLabel="Select Provider"></nz-option>
                @for (group of NotificationGroupList; track group) {
                  <nz-option [nzValue]="group.NotificationGroupUserId"
                  [nzLabel]="group.Name"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="8" nzRequired>Enabled</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input type="checkbox" (change)="setEnabled($event)" formControlName="Enabled" name="OnlyInternal" />
            </nz-form-control>
          </nz-form-item>
        </form>
      </ng-template>

      <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">
          Cancel
        </button>
        @if (permission.Add || permission.Edit) {
          <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isLoading">
            Save Mapping
          </button>
        }
      </ng-template>
    </nz-modal>
  </div>
</div>